// src/services/jobsService.js
import apiClient from './apiClient.js'

export const jobsService = {
    getJobs(params = {}) {
        return apiClient.get('/jobs', { params })
    },

    getJobsAdmin(params = {}) {
        return apiClient.get('/jobs/admin', { params })
    },

    getJobBySlug(slug) {
        return apiClient.get(`/jobs/slug/${slug}`)
    },

    createJob(data) {
        return apiClient.post('/jobs', data)
    },

    updateJob(id, data) {
        return apiClient.put(`/jobs/${id}`, data)
    },

    deleteJob(id) {
        return apiClient.delete(`/jobs/${id}`)
    },
}